import { render, staticRenderFns } from "./AddReduceBalance.vue?vue&type=template&id=68e5dab5&"
import script from "./AddReduceBalance.vue?vue&type=script&lang=js&"
export * from "./AddReduceBalance.vue?vue&type=script&lang=js&"
import style0 from "./AddReduceBalance.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports